// @ts-nocheck
import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import home from '../views/main-modules/home.vue'
import vueCookie from 'vue-cookies'
import utils from '../utils'
import routerConfig from './router-config'
import https, {fetch, post, adornUrl} from '../utils/https'



const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: home,
    children: [
      {
        path: '/',
        name: '首页',
        component: () => import('../views/main-modules/dashboard.vue'),
      },    
      ...routerConfig    
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/main-modules/login.vue'),
  },
  {
    path: '/register',
    component: () => import('../views/main-modules/register'),
    name: 'register'
    
  },
  {
    path: '/lgtaoic',
    component: () => import('../views/main-modules/lgtaoic'),
    name: 'lgtaoic'
  },
  {
    path: '/authentication',
    name: 'authentication',
    component: () => import('../views/main-modules/authentication.vue'),
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('../views/main-modules/forgot-password.vue')
  },
  {
    path: '/sso',
    name: 'sso',
    component: () => import('../views/main-modules/sso.vue')
  },
  {
    path: '/:catchAll(.*)',
   component: () => import('../views/main-modules/404.vue')
 }
]

const main: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: home,
    children: [
      ...routerConfig
    ]
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  isAddDynamicMenuRoutes: false,
  routes
})



router.beforeEach((to,from,next) => {
  console.log(111)
  let token = vueCookie.get('token')
  let menuList = JSON.parse(sessionStorage.getItem('menuList') || '[]').filter(e => e.isShow)
  if (to.path == '/login' || to.path == '/forgot-password' || to.path == '/sso' || to.path == '/register' || to.path == '/lgtaoic' || to.fullPath.indexOf('/authentication') != -1) {
    next()
  } else if (!token || !/\S/.test(token) && to.fullPath != '/login') {
    utils.tools.clearLoginInfo()
    next({ path: '/login',replace: true})
  } else {
    next()
    // if (router.options.isAddDynamicMenuRoutes) {
    //   next()
    // } else {
    //   let bizType = JSON.parse(sessionStorage.getItem('bizType') || '{}')
    //   post('/p/menu/queryTreeByUserIdAndAppId',{
    //     userId: '',
    //     businessType: 'CLIENT',
    //     bizTypeGroup: bizType.bizTypeGroup
    //   }).then(({data}) => {
    //     if (data && data.code === 'C0000') {
    //       let resultList = [data.result.menuList[1]]
    //       fnAddDynamicMenuRoutes(resultList[0].children)
         
         
    //       router.options.isAddDynamicMenuRoutes = true
    //       sessionStorage.setItem('menuList', JSON.stringify(resultList[0].children) || '[]')
    //       sessionStorage.setItem('lastUpdateTime', new Date().getTime())
    //       sessionStorage.setItem('permissions', JSON.stringify(data.result.permissions || '[]'))
    //       console.log(router)
    //       next({
    //         ...to,
    //         replace: true
    //       })
    //     } else {
    //       next()
    //     }
    //   })
    // }
   
  }
})

/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
 function fnAddDynamicMenuRoutes (menuList = []) {
  var temp = []
  for (var i = 0; i < menuList.length; i++) {
    if (menuList[i].url && /\S/.test(menuList[i].url)) {
      temp.push(menuList[i])
    }
    if (menuList[i].children && menuList[i].children.length >= 1) {
      temp = temp.concat(menuList[i].children.filter(e => {e.isShow}))
    }
  }
  if (temp) {
    temp.map(e => {
      var obj = {
        path: e.url,
        name: e.url,
        component: () => require(`../views/${e.url}.vue`),
        meta: {
          menuId: e.id,
          title: e.name
        }
      }
      // try {
      //   let filePach = `../views/${e.url}.vue`
      //   obj['component'] = () => import(filePach) || null
      // } catch(e) {

      // }
      console.log(obj)
      router.addRoute('/', main)
    })
    return temp
  }
 }

export default router
